module.exports = __webpack_public_path__ + "static/media/big-bruneau.34d39ae3.jpg";